module.exports = __webpack_public_path__ + "static/day3-713ded848b97769017a577bf8b80eb2e.mp4";